import React, { useCallback } from 'react';
import { Typography } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

export default function FilterViewTab({ view, onFavourite }) {
  const handleFavouriteClick = useCallback((e) => {
    e.stopPropagation();
    if (onFavourite) {
      onFavourite(view.id, !view.isFavourite);
    }
  }, [view, onFavourite]);

  const StarIcon = view.isFavourite ? StarFilled : StarOutlined;

  return (
    <span className="filter-view-tab">
      <Typography.Text
        style={{
          maxWidth: 200,
        }}
        ellipsis
      >
        {view.filterViewName}
      </Typography.Text>
      {onFavourite && (
        <StarIcon
          className="filter-view-favourite-icon"
          style={{
            marginLeft: 8,
            color: view.isFavourite ? '#fadb14' : '#d9d9d9',
            fontSize: 14,
          }}
          onClick={handleFavouriteClick}
        />
      )}
    </span>
  );
}

FilterViewTab.propTypes = {
  view: PropTypes.shape({
    id: PropTypes.string,
    filterViewName: PropTypes.string,
    isFavourite: PropTypes.bool,
  }).isRequired,
  onFavourite: PropTypes.func,
};

FilterViewTab.defaultProps = {
  onFavourite: null,
};
